<div class="stepper">
  <div class="track"></div>
  <div
    class="progress"
    [style.width.%]="(currentStep / totalSteps) * 100"
  ></div>

  @for (step of steps; track step; let i = $index) {
    <div
      class="step"
      [style.left.%]="((i + 1) / totalSteps) * 100"
      >
      <div
        class="circle"
        [class.completed]="(i + 1) < currentStep"
        [class.active]="(i + 1) === currentStep"
        >
        <span>✓</span>
      </div>
    </div>
  }
</div>
